import { render, staticRenderFns } from "./CreateTestimonials.vue?vue&type=template&id=fb4a3162&"
import script from "./CreateTestimonials.vue?vue&type=script&lang=js&"
export * from "./CreateTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./CreateTestimonials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports